import request from '../utils/request';

export async function getTransfers(params) {
  return request('/api/transfers', {
    method: 'GET',
    params,
  });
}
